import { cleanUrl } from './clean-url';
/**
 *
 * @param baseUrl
 * @param version
 */
export function createBaseUrl(baseUrl, version = '') {
    let cleanedBaseUrl = '';
    if (baseUrl) {
        cleanedBaseUrl = cleanUrl(baseUrl) + '/';
    }
    if (version) {
        cleanedBaseUrl = `${cleanedBaseUrl}${cleanUrl(version)}/`;
    }
    return cleanedBaseUrl;
}
//# sourceMappingURL=create-base-url.js.map